import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {AccountLink} from 'src/components/links';

import {PLACE} from '../../constants';
import {
    accountSearchResultMobileUsersDataSelector,
    accountSearchResultMobileUsersResultSelector,
} from '../../slices/account-search-result-mobile-users.slice';

type Props = {
    accountId: number,
};

export const MobileEnabledUsersCell = ({accountId}: Props) => {
    const {isLoading, loadingError} = useSelector(accountSearchResultMobileUsersDataSelector);
    const result = useSelector(accountSearchResultMobileUsersResultSelector);

    const count = useMemo(() => result?.data[accountId], [result, accountId]);

    if (isLoading || loadingError || !count) {
        return null;
    }

    return (
        <AccountLink
            accountId={accountId}
            place={PLACE}
            accountName={count.toString()}
            target="users-groups/mobile"
        />
    );
};
